'use strict';

import Button from '@material-ui/core/Button';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import CheckedIcon from 'Icons/Checked';
import bemit from 'Functions/bemit';
export default function PaymentSuccess(props) {
  const output = /*#__PURE__*/React.createElement("div", {
    className: bemit('c-payment-form', ['success'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-payment-form__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['v2', 'green', 'icon'])
  }, /*#__PURE__*/React.createElement(CheckedIcon, {
    className: "c-message__icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, props.free === true ? 'Merci d\'avoir réservé avec myWO, nous vous avons envoyé un email de confirmation.' : 'Paiement réussi. Un email de confirmation vous a été envoyé.')), props['hide-home-button'] ? undefined : /*#__PURE__*/React.createElement(Button, {
    type: "button",
    href: "/",
    className: bemit('c-arrow-btn', ['primary', 'big']) + ' u-margin-top-10'
  }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
    className: "c-arrow-btn__arrow"
  }), /*#__PURE__*/React.createElement("span", {
    className: "c-arrow-btn__text"
  }, "Revenir \xE0 l'accueil de myWO"))));
  return output;
}
